// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: プロンプトのバージョンの変更メモを編集
const AdminOpsPromptMessageApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_prompt_message";

    const ExecAdminOpsPromptMessageApi = async (groupKey, v, message) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { group_key: groupKey, v: v, message: message } });
    };

    return ExecAdminOpsPromptMessageApi;
};

export default AdminOpsPromptMessageApi;
